export const packingSuppliesLevelThree = [
    {
        "name": "Self Lock Poly Bag",
        "categoryId": "self_lock_poly_bag",
        "parentCategoryName": "Packing Materials",
        "parentCategoryId": "packing_materials",
        "level": 3
    },
    {
        "name": "Zip Lock Poly Bag",
        "categoryId": "zip_lock_poly_bag",
        "parentCategoryName": "Packing Materials",
        "parentCategoryId": "packing_materials",
        "level": 3
    }
]